// extracted by mini-css-extract-plugin
export default {"link":"SubModalTitle_link__NGSlm"};